import { Model } from "pinia-orm";
import Scenario from "@/models/Scenario";
import Batch from "@/models/Batch";

export default class BatchScenario extends Model {
  static entity = "batchScenarios";
  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(""),
      scenarioUuid: this.string(""),
      scenarioData: this.belongsTo(Scenario, "scenarioUuid", "uuid"),
      batchUuid: this.string(""),
      batchData: this.belongsTo(Batch, "batchUuid", "uuid"),
      order: this.number(null),
    };
  }
}
